import { APP_NAME, PRIVACY_EMAIL, SUPPORT_EMAIL } from '../../config/branding';
import raw from './legalCopyData.json';

export const LEGAL_UPDATED: string = raw.updated;
export const LEGAL_DEVELOPER: string = raw.developer;
export const LEGAL_SITE: string = raw.site;

export type LegalBlock =
  | { type: 'highlight'; text: string }
  | { type: 'h'; text: string }
  | { type: 'p'; text: string }
  | { type: 'ul'; items: string[] }
  | { type: 'ol'; items: string[] }
  | { type: 'steps'; items: string[] }
  | { type: 'cta'; text: string; href: string };

const TOKENS: Record<string, string> = {
  '{{APP_NAME}}': APP_NAME,
  '{{PRIVACY_EMAIL}}': PRIVACY_EMAIL,
  '{{SUPPORT_EMAIL}}': SUPPORT_EMAIL,
  '{{DEVELOPER}}': raw.developer,
  '{{SITE}}': raw.site,
};

export function fillLegalText(text: string): string {
  return Object.entries(TOKENS).reduce((acc, [token, value]) => acc.split(token).join(value), text);
}

function fillBlock(block: LegalBlock): LegalBlock {
  if (block.type === 'ul' || block.type === 'ol' || block.type === 'steps') {
    return { ...block, items: block.items.map(fillLegalText) };
  }
  if (block.type === 'cta') {
    return { type: 'cta', text: fillLegalText(block.text), href: fillLegalText(block.href) };
  }
  return { ...block, text: fillLegalText(block.text) };
}

export const PRIVACY_BLOCKS: LegalBlock[] = (raw.privacy as LegalBlock[]).map(fillBlock);
export const TERMS_BLOCKS: LegalBlock[] = (raw.terms as LegalBlock[]).map(fillBlock);
export const DELETE_ACCOUNT_BLOCKS: LegalBlock[] = (raw.deleteAccount as LegalBlock[]).map(fillBlock);
